import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../atoms/button/button';
import styles from '../commissions.module.scss';
import { useAppDispatch, useAppSelector } from '../../../../reducers';
import { UpdateRolesRelations } from '../commissionModals/updateRolesRelations';
import { openModal } from '../../../../reducers/modal.reducer';
import { UpdateUsersRelations } from '../commissionModals/updateUsersRelations';
import { updateCommissionGlobal } from '../../../../reducers/updates-commission-relations.reducer';
import { UpdateGlobalCommission } from '../commissionModals/updateGlobalCommission';
import { getCommission } from '../../../../reducers/commissions.reducer';
import Spinner from '../../../atoms/spinner/spinner';
import Flex from '../../../atoms/flex/flex';
import { Heading } from '../../../atoms/heading/heading';

export const CommissionDetail = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { loading, success, failure, commissionDetail, refresh } = useAppSelector(state => state.commissions);

  const commissionId = Number(params.id);

  const updateUsersRelations = () => {
    dispatch(
      openModal({
        children: <UpdateUsersRelations commissionId={commissionId} associatedUsers={commissionDetail.relations.users} />,
        opt: {
          size: 'sm',
          type: 'default',
          title: 'Modifica utenti associati',
        },
      })
    );
  };

  const updateRolesRelations = () => {
    dispatch(
      openModal({
        children: <UpdateRolesRelations commissionId={commissionId} associatedRoles={commissionDetail.relations.roles} />,
        opt: {
          size: 'sm',
          type: 'default',
          title: 'Modifica ruoli associati',
        },
      })
    );
  };

  const updateGlobalCommission = () => {
    if (
      commissionDetail.commission.global ||
      (commissionDetail.relations.users.length === 0 && commissionDetail.relations.roles.length === 0)
    ) {
      dispatch(
        updateCommissionGlobal({
          commissionId,
        })
      );
    } else {
      dispatch(
        openModal({
          children: <UpdateGlobalCommission commissionId={commissionId} />,
          opt: {
            size: 'xs',
            type: 'default',
            title: 'Modifica commessa globale',
          },
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      getCommission({
        commissionId,
      })
    );
  }, [dispatch, navigate, commissionId, refresh]);

  return (
    <>
      <div className="container md m-auto">
        {loading && <Spinner className={styles.spinner} />}
        {!loading && failure && <div>Errore nel caricamento dei dati. Riprova più tardi.</div>}
        {!loading && success && commissionDetail && (
          <Flex container flexDirection="column" gap={10}>
            <Flex container alignItems="center" gap={10} className="mt-1 mb-1">
              <Button size="sm" color="white" rounded="rounded-sm" mode="outline" onClick={() => navigate(-1)}>
                Indietro
              </Button>
              <Flex container flexDirection="column">
                <Heading size={2} content="Modifica commessa" />
                <div className="mt-05">{commissionDetail.commission.commissionName}</div>
              </Flex>
              <Button
                className="ml-auto"
                size="md"
                mode="outline"
                color={`${!global ? 'white' : 'black'}`}
                rounded="rounded-md"
                onClick={updateGlobalCommission}
              >
                Commessa globale: {commissionDetail.commission.global ? 'Si' : 'No'}
              </Button>
            </Flex>

            <div>
              <Flex container alignItems="center" className="mb-1">
                <h3>Utenti</h3>
                <Button
                  className="ml-auto"
                  size="sm"
                  color="white"
                  rounded="rounded-sm"
                  mode="outline"
                  onClick={updateUsersRelations}
                  disabled={commissionDetail?.commission.global}
                >
                  Modifica utenti associati
                </Button>
              </Flex>
              <div className={styles.userOrRoleCardWrapper}>
                {commissionDetail.relations.users.length > 0 ? (
                  commissionDetail.relations.users.map(user => (
                    <div className={styles.userOrRoleCard} key={user.id}>
                      {user.email}
                    </div>
                  ))
                ) : (
                  <div>Nessun utente associato</div>
                )}
              </div>
            </div>
            <div>
              <Flex container alignItems="center" className="mb-1">
                <h3>Ruoli</h3>
                <Button
                  className="ml-auto"
                  size="sm"
                  color="white"
                  rounded="rounded-sm"
                  mode="outline"
                  onClick={updateRolesRelations}
                  disabled={commissionDetail?.commission.global}
                >
                  Modifica ruoli associati
                </Button>
              </Flex>
              <div className={styles.userOrRoleCardWrapper}>
                {commissionDetail.relations.roles.length > 0 ? (
                  commissionDetail.relations.roles.map(role => (
                    <div className={styles.userOrRoleCard} key={role.id}>
                      {role.name}
                    </div>
                  ))
                ) : (
                  <div>Nessun ruolo associato</div>
                )}
              </div>
            </div>
          </Flex>
        )}
      </div>
    </>
  );
};
